import { BaasicDropdownStore, BaseEditViewStore } from 'core/stores';
import { FacilityOrderPatientNewFlowInsuranceNoteModalForm } from 'application/facility-order-new-flow-insurance/forms';
import { FacilityOrderPatientNewFlowInsuranceInsuranceEditViewStore } from 'application/facility-order-new-flow-insurance/stores';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { EligibilityStatusService } from 'application/eligibility-status/services';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { action, observable } from "mobx";
import { ModalParams } from 'core/models';
import _ from 'lodash';

class FacilityOrderPatientNewFlowInsuranceNoteModalStore extends BaseEditViewStore {
    @observable accessor facilityOrderTemplates = null;
    @observable accessor showTemplates = false;
    @observable accessor isEligibleInsuranceStatus = false;

    @observable accessor selectedTabItemAbrv = 'insurance-eligibility';
    tabItems = [{ abrv: 'insurance-eligibility', name: 'Insurance Eligibility' }, { abrv: 'insurances', name: 'Insurances' }];

    constructor(rootStore, componentProps) {
        const facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        const facilityOrderPatient = componentProps.modalParams.data.facilityOrderPatient;

        super(rootStore, {
            name: 'facility-order-patient-new-flow-insurance-add-note-modal',
            Form: FacilityOrderPatientNewFlowInsuranceNoteModalForm,
            id: facilityOrderPatient && facilityOrderPatient.id,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                        return facilityOrderPatient.eligibilityStatusId ? { ...facilityOrderPatient, eligibilityId: facilityOrderPatient.eligibilityStatusId } : facilityOrderPatient;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderPatientService.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await facilityOrderPatientService.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: FacilityOrderPatientNewFlowInsuranceNoteModalForm,
            autoInit: false
        });

        this.eligibilityStatusService = new EligibilityStatusService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;

        this.facilityOrderPatient = facilityOrderPatient;
        this.facilityOrderPatientService = facilityOrderPatientService;

        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.patient = this.modalParams.data.patient;

        this.facilityOrderTemplates = _.map(this.modalParams.data.facilityOrderTemplates, i => { return { ...i, itemsVisible: false }; })
        this.oldFacilityOrderTemplates = this.modalParams.data.facilityOrderTemplates;

        this.isNewPatient = this.facilityOrderPatient.isNewPatient,
        this.isInitialEligibleInsuranceStatus = this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible";
        this.isEligibleInsuranceStatus = this.facilityOrderPatient.eligibilityStatus && this.facilityOrderPatient.eligibilityStatus.name === "Eligible";

        this.setNewFlowStatus = this.modalParams.data.setNewFlowStatus;
        this.changeFacilityOrderPatientInsuranceStatus = this.modalParams.data.changeFacilityOrderPatientInsuranceStatus;
        this.refreshInsuranceData = this.modalParams.data.refreshInsuranceData;
        this.fetchPatientTemplates = this.modalParams.data.fetchPatientTemplates;
        this.showTemplateChangeWarning = this.modalParams.data.showTemplateChangeWarning;

        this.relationshipChangeModal = new ModalParams({});
        this.facilityOrderPatientNewFlowInsuranceInsuranceEditViewStore = new FacilityOrderPatientNewFlowInsuranceInsuranceEditViewStore(this.rootStore, { patient:this.patient, refreshInsuranceData: this.refreshInsuranceData, openRelationshipChangeModal: async () => await this.openRelationshipChangeModal(), changeFacilityOrderPatientInsuranceStatus: this.changeFacilityOrderPatientInsuranceStatus ? () => this.changeFacilityOrderPatientInsuranceStatus() : null, facilityOrderPatient: this.facilityOrderPatient, facilityOrderTemplates: this.facilityOrderTemplates, fetchPatientTemplates: this.fetchPatientTemplates });

        this.eligibilityStatusStore = new BaasicDropdownStore({
            filterable: true,
        }, {
            fetchFunc: async (term) => {
                const response = await this.eligibilityStatusService.find({
                    searchQuery: term,
                    rpp: 50
                });
                return response.data.item;
            },
            onChange: async () => {
                this.isEligibleInsuranceStatus = this.isEligibleInsuranceStatus !== undefined && this.eligibilityStatusStore.value && this.eligibilityStatusStore.value.name === "Eligible";
            }
        });

        this.fetch([
            this.initialize()
        ]);
    }
    async initialize() {
        if (this.isEdit) {
            await this.getResource(this.id);
        } else {
            this.form.clear();
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            let isParUpdated = false;
            let isPriorAuthNeededUpdated = false;
            this.facilityOrderTemplates.forEach(async (t) => {
                let oldTemplate = this.oldFacilityOrderTemplates.find(x => x.id === t.id);
                if(oldTemplate && oldTemplate.isPriorAuthNeeded != t.isPriorAuthNeeded){
                    isPriorAuthNeededUpdated = true;
                    if (t.isClinicalReviewed) {
                        isParUpdated = true;
                    }
                }
            });

            if(this.showTemplateChangeWarning)
                this.showTemplateChangeWarning(null, (this.isInitialEligibleInsuranceStatus && !this.isEligibleInsuranceStatus), true, (!this.isInitialEligibleInsuranceStatus && this.isEligibleInsuranceStatus), isParUpdated);

            await this.actions.update({
                id: this.id,
                facilityOrderId: this.facilityOrderId,
                patientId: this.patient.id,
                eligibilityStatusId: resource.eligibilityId,
                isNewPatient: this.isNewPatient,
                insuranceInfo: this.facilityOrderPatient.insuranceInfo,
                eligibilityStatusNote: this.facilityOrderPatient.eligibilityStatusNote,
                updateDoNotSupply: true,
                activeStatus: this.facilityOrderPatient.activeStatus,
                ...resource
            });
            
            // this.facilityOrderTemplates.forEach(async (t) => {
			// 	let oldTemplate = this.oldFacilityOrderTemplates.find(x => x.id === t.id);
            //     if(oldTemplate && oldTemplate.isPriorAuthNeeded != t.isPriorAuthNeeded){                    
            //         await this.facilityOrderTemplateService.updatePriorAuthNeeded({ id: t.id, isPriorAuthNeeded: t.isPriorAuthNeeded });
            //     }
			// });

            let updatePromises = this.facilityOrderTemplates.map(async (t) => {
                let oldTemplate = this.oldFacilityOrderTemplates.find(x => x.id === t.id);
                if (oldTemplate && oldTemplate.isPriorAuthNeeded != t.isPriorAuthNeeded) {                    
                    return this.facilityOrderTemplateService.updatePriorAuthNeeded({ id: t.id, isPriorAuthNeeded: t.isPriorAuthNeeded });
                }
            });
            await Promise.all(updatePromises);

            this.form.setFieldsDisabled(false);
            const isEligibilityUpdate = this.facilityOrderPatient.eligibilityStatusId != resource.eligibilityId;
            if(this.facilityOrderPatient.eligibilityStatusId != resource.eligibilityId){
                this.facilityOrderPatient.eligibilityStatusNote = await this.facilityOrderPatientService.get(this.facilityOrderPatient.id, { fields: "eligibilityStatusNote"});
                if (this.fetchPatientTemplates) {
                    await this.fetchPatientTemplates();
                }
            }

            this.facilityOrderPatient.eligibilityStatusId = resource.eligibilityId;
            this.facilityOrderPatient.note = resource.note;
            this.facilityOrderPatient.effectiveDate = resource.effectiveDate;
            
            await this.setNewFlowStatus(isEligibilityUpdate || isPriorAuthNeededUpdated, (this.isInitialEligibleInsuranceStatus && !this.isEligibleInsuranceStatus));
                        
            await this.modalParams.close();
            await setTimeout(() => this.notifySuccessUpdate(this.name), 10);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create({
                facilityOrderId: this.facilityOrderId,
                patientId: this.patient.id,
                eligibilityStatusId: resource.eligibilityId,
                isNewPatient: this.isNewPatient,
                insuranceInfo: this.facilityOrderPatient.insuranceInfo,
                updateDoNotSupply: true,
                activeStatus: this.facilityOrderPatient.activeStatus,
                ...resource
            });

            let isParUpdated = false;

            this.facilityOrderTemplates.forEach(async (t) => {
				let oldTemplate = this.oldFacilityOrderTemplates.find(x => x.id === t.id);
                if(oldTemplate && oldTemplate.isPriorAuthNeeded != t.isPriorAuthNeeded){
                    if(t.isClinicalReviewed)
                        isParUpdated = true;
                    
                    await this.facilityOrderTemplateService.updatePriorAuthNeeded({ id: t.id, isPriorAuthNeeded: t.isPriorAuthNeeded });
                }
			});

            this.form.setFieldsDisabled(false);

            if (this.fetchPatientTemplates) {
                await this.fetchPatientTemplates();
            }

            await this.setNewFlowStatus();

            if (this.fetchPatientTemplates) {
                await this.fetchPatientTemplates();
            }

            if(this.showTemplateChangeWarning)
                this.showTemplateChangeWarning(null, (this.isInitialEligibleInsuranceStatus && !this.isEligibleInsuranceStatus), true, (!this.isInitialEligibleInsuranceStatus && this.isEligibleInsuranceStatus), isParUpdated);

            await this.modalParams.close();
            await setTimeout(() => this.notifySuccessCreate(), 10);            
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onCreateError(err);
        }
    }

    @action.bound
    setPriorAuthNeededd(facilityOrderTemplate) {
        facilityOrderTemplate.isPriorAuthNeeded = !facilityOrderTemplate.isPriorAuthNeeded;
    }

    @action.bound
    changeItemsVisibility(facilityOrderTemplate) {
        facilityOrderTemplate.itemsVisible = !facilityOrderTemplate.itemsVisible;
    }

    @action.bound
    changeTemplatesVisibility() {
        this.showTemplates = !this.showTemplates;
    }

    @action.bound
    async setTabItem(tabItemAbrv) {
        this.selectedTabItemAbrv = tabItemAbrv;
    }

    @action.bound
    async openRelationshipChangeModal() {
        this.relationshipChangeModal.open({ patientKey: this.patient.patientKey });
    }

}

export default FacilityOrderPatientNewFlowInsuranceNoteModalStore;